<div [class]="className">
  <mat-tab-group
    [selectedIndex]="selectedIndex"
    (selectedTabChange)="clickEvent($event)"
  >
    <ng-container *ngFor="let tab of tabs">
      <mat-tab [disabled]="tab.isDisabled" label="{{ tab.label }}"> </mat-tab>
    </ng-container>
  </mat-tab-group>
</div>
